module.exports = __webpack_public_path__ + "img/Union.5c857f5a.svg";